
import {SET_MODAL_INFO} from './_CONSTANTS';

export const setModalInfo = (obj) => {
  return {
    type: SET_MODAL_INFO,
    payload: obj
  }
}
